<div class="generic-list">
  <p-table
    [value]="tableData"
    [dataKey]="dataKey"
    (onLazyLoad)="onLazyLoad($event)"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [lazy]="true"
    [scrollable]="true"
    scrollHeight="flex"
    [paginator]="showPaginator"
    [multiSortMeta]="multiSortMeta"
    [selectionMode]="selectionMode"
    [(selection)]="selectedItems"
    (selectionChange)="selectedItemsChange.emit($event)"
    (onRowSelect)="rowSelectChange.emit($event)"
    (onRowUnselect)="rowUnselectChange.emit($event)"
    [sortMode]="enableSort ? 'multiple' : 'single'"
    [rowExpandMode]="rowExpandMode === 'single' ? 'single' : 'multiple'"
    [expandedRowKeys]="expandedRowKeys"
    [styleClass]="styleClass + ' p-datatable-gridlines'"
    [rows]="100"
    [resizableColumns]="true"
    [groupRowsBy]="groupRowsBy"
    [rowGroupMode]="!!groupRowsBy ? 'subheader' : undefined"
    columnResizeMode="expand"
    stripedRows>

    <ng-template pTemplate="header">
      <!-- row for column headers / sort-->
      <tr>
        @if (rowExpandMode !== 'none') {
          <th scope="col" style="width: 3rem"></th>
        }
        @if (checkboxSelection) {
          <th scope="col" style="min-width: 60px; flex-grow: unset; text-align: center">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
        }
        @for (column of columns; track column.key) {
          @if (visibleColumnKeys.includes(column.key)) {
            <th pResizableColumn [pSortableColumnDisabled]="!column.enableSort" [pSortableColumn]="column.sortKey || column.key" [style]="'min-width:' + column.minWidth" [class]="column.cellHeadingClass"
              >
              <div class="generic-column-header-div">
                {{column.title}}
                @if (column.tooltip) {
                  <i [pTooltip]="column.tooltip" class="fa fa-solid fa-circle-info ml-1"></i>
                }
                @if (column.enableSort) {
                  <p-sortIcon [field]="column.sortKey || column.key" />
                }
                @if (column.filterType === FilterType.SELECT) {
                  <p-columnFilter [field]="column.filterKey || column.key" matchMode="equals" display="menu"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    [ngClass]="hasActiveFilter(column.filterKey || column.key)">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [optionValue]="column.filterValueField || 'value'" [optionLabel]="column.filterLabelField" [options]="column.filterOptions"
                        [filter]="true" [filterBy]="column.filterLabelField" class="form-field"
                        (onChange)="filterCallback($event.value)" i18n-placeholder="@@common-choose" placeholder="(choose)">
                        <ng-template let-option pTemplate="option">
                          <!-- if there is a value for `filterOptionsTemplate`, use that as the template
                          for the filter options -->
                          <ng-container *ngTemplateOutlet="column.filterOptionsTemplate || defaultSelectFilterTemplate; context:{ $implicit: option }"></ng-container>
                          <!-- otherwise fallback to this -->
                          <ng-template let-option pTemplate="item" #defaultSelectFilterTemplate>
                            {{option[column.filterLabelField]}}
                          </ng-template>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @if (column.filterType === FilterType.MSELECT) {
                  <p-columnFilter [field]="column.filterKey || column.key" matchMode="in" display="menu"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    [ngClass]="hasActiveFilter(column.filterKey || column.key)">
                    <!-- for explanation: https://github.com/primefaces/primeng/blob/17.3.0/src/app/components/table/table.ts#L5674 -->
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-multiSelect [ngModel]="value" [optionValue]="column.filterValueField || 'value'" [optionLabel]="column.filterLabelField" [options]="column.filterOptions"
                        [filter]="true" [filterBy]="column.filterLabelField" [group]="column.group"
                        scrollHeight="300px" display="chip" [maxSelectedLabels]="100" class="form-field"
                        (onChange)="filterCallback($event.value)" i18n-placeholder="@@common-choose" placeholder="(choose)">
                        <ng-template let-group pTemplate="group">
                          <div class="flex align-items-center">
                            <p-checkbox [value]="group.value" [(ngModel)]="column.checkedFilterGroups"
                              (click)="multiSelectGroupSelectChanged(column.checkedFilterGroups, group, value, filterCallback)"
                              class="mr-2">
                            </p-checkbox>
                            <span>{{ group.label }}</span>
                          </div>
                        </ng-template>
                        <ng-template let-option pTemplate="option">
                          <!-- if there is a value for `filterOptionsTemplate`, use that as the template
                          for the filter options -->
                          <ng-container *ngTemplateOutlet="column.filterOptionsTemplate || defaultMSelectFilterTemplate; context:{ $implicit: option }"></ng-container>
                          <!-- otherwise fallback to this -->
                          <ng-template let-option pTemplate="item" #defaultMSelectFilterTemplate>
                            {{option[column.filterLabelField]}}
                          </ng-template>
                        </ng-template>
                      </p-multiSelect>
                    </ng-template>
                  </p-columnFilter>
                }
                @if (column.filterType === FilterType.DATE) {
                  <p-columnFilter #dateColumnFilter type="date" [field]="column.filterKey || column.key" display="menu"
                    [showOperator]="false" [showAddButton]="true" [matchModeOptions]="matchModeOptions(dateColumnFilter.config, 'date')"
                    [ngClass]="hasActiveFilter(column.filterKey || column.key)">
                    <!-- for explication: https://github.com/primefaces/primeng/blob/15.4.1/src/app/components/table/table.ts#L5007 -->
                    <ng-template pTemplate="filter" let-filterCallback="filterCallback" let-value let-filterConstraint="filterConstraint" let-field="field">
                      @switch (filterConstraint.matchMode) {
                        @case ('exists') {
                          <span>
                            <p-checkbox [inputId]="field + '-checkbox'" [binary]="true" [ngModel]="isBoolean(value) ? value : null" (onChange)="filterCallback($event.checked)"></p-checkbox>
                            <label [for]="field + '-checkbox'" class="ml-2">
                              @switch (value) {
                                @case (true) {
                                  <span i18n="@@common-yes">Yes</span>
                                }
                                @case (false) {
                                  <span i18n="@@common-no">No</span>
                                }
                                @default {
                                  <span i18n="@@common-no_filter">Activate the filter</span>
                                }
                              }
                            </label>
                          </span>
                        }
                        @default {
                          <p-date-picker dateFormat="yy-mm-dd" [ngModel]="value" (onSelect)="filterCallback($event)" view="date" dataType="string"></p-date-picker>
                        }
                      }
                    </ng-template>
                  </p-columnFilter>
                }
                @if (column.filterType === FilterType.MONTH) {
                  <p-columnFilter type="date" [field]="column.filterKey || column.key" display="menu" [showMatchModes]="column.showMatchModes" [showOperator]="false" [showAddButton]="true">
                    <ng-template pTemplate="filter" let-filter="filterCallback" let-value>
                      <p-date-picker dateFormat="yy-mm" [ngModel]="value" (onSelect)="filter($event)" view="month" dataType="string"></p-date-picker>
                    </ng-template>
                  </p-columnFilter>
                }
                @if (column.filterType === FilterType.NUMERIC) {
                  <p-columnFilter #numericColumnFilter type="numeric" [field]="column.filterKey || column.key" display="menu"
                    [showMatchModes]="column.showMatchModes" [matchModeOptions]="matchModeOptions(numericColumnFilter.config, 'numeric')" [showOperator]="false" [showAddButton]="true"
                    [ngClass]="hasActiveFilter(column.filterKey || column.key)">
                    <ng-template pTemplate="filter" let-value let-filterConstraint="filterConstraint" let-filterCallback="filterCallback"
                      let-field="field" let-placeholder="placeholder" let-type="type" let-showButtons="showButtons"
                      let-minFractionDigits="minFractionDigits" let-maxFractionDigits="maxFractionDigits" let-prefix="prefix" let-suffix="suffix"
                      let-currency="currency" let-currencyDisplay="currencyDisplay" let-localeMatcher="localeMatcher"
                      let-useGrouping="useGrouping">
                      @switch (filterConstraint.matchMode) {
                        @case ('exists') {
                          <span>
                            <p-checkbox [inputId]="field + '-checkbox'" [binary]="true"  [ngModel]="isBoolean(value) ? value : null" (onChange)="filterCallback($event.checked)"></p-checkbox>
                            <label [for]="field + '-checkbox'" class="ml-2">
                              @switch (value) {
                                @case (true) {
                                  <span i18n="@@common-yes">Yes</span>
                                }
                                @case (false) {
                                  <span i18n="@@common-no">No</span>
                                }
                                @default {
                                  <span i18n="@@common-no_filter">Activate the filter</span>
                                }
                              }
                            </label>
                          </span>
                        }
                        @default {
                          <p-inputNumber
                            [ngModel]="filterConstraint?.value" (ngModelChange)="onModelChange(filterConstraint, type, $event)"
                            (onKeyDown)="onNumericInputKeyDown($event)" [showButtons]="showButtons"
                            [minFractionDigits]="minFractionDigits" [maxFractionDigits]="maxFractionDigits" [prefix]="prefix" [suffix]="suffix"
                            [placeholder]="placeholder" [mode]="currency ? 'currency' : 'decimal'"
                            [locale]="locale" [localeMatcher]="localeMatcher"
                            [currency]="currency" [currencyDisplay]="currencyDisplay"
                            [useGrouping]="useGrouping">
                          </p-inputNumber>
                        }
                      }
                    </ng-template>
                  </p-columnFilter>
                }
                @if (column.filterType === FilterType.TEXT) {
                  <p-columnFilter #textColumnFilter type="text" [field]="column.filterKey || column.key" display="menu"
                    [showOperator]="false" [showAddButton]="false" [matchMode]="column.matchMode" [showMatchModes]="column.showMatchModes"
                    [matchModeOptions]="matchModeOptions(textColumnFilter.config, 'text')" [ngClass]="hasActiveFilter(column.filterKey || column.key)">
                    <ng-template pTemplate="filter" let-value let-filterConstraint="filterConstraint" let-filterCallback="filterCallback" let-field="field" let-placeholder="placeholder" let-type="type">
                      @switch (filterConstraint.matchMode) {
                        @case ('exists') {
                          <span>
                            <p-checkbox [inputId]="field + '-checkbox'" [binary]="true" [ngModel]="isBoolean(value) ? value : null" (onChange)="filterCallback($event.checked)"></p-checkbox>
                            <label [for]="field + '-checkbox'" class="ml-2">
                              @switch (value) {
                                @case (true) {
                                  <span i18n="@@common-yes">Yes</span>
                                }
                                @case (false) {
                                  <span i18n="@@common-no">No</span>
                                }
                                @default {
                                  <span i18n="@@common-no_filter">Activate the filter</span>
                                }
                              }
                            </label>
                          </span>
                        }
                        @default {
                          <input type="text" pInputText [value]="filterConstraint?.value" (input)="onModelChange(filterConstraint, type, $any($event.target).value)" (keydown.enter)="onTextInputEnterKeyDown(filterConstraint, $event)" [attr.placeholder]="placeholder" />
                        }
                      }
                    </ng-template>
                  </p-columnFilter>
                }
              </div>
            </th>
          }
        }
      </tr>

    </ng-template>

    @if (groupRowsBy !== undefined) {
      <ng-template pTemplate="groupheader" let-item>
        <tr pRowGroupHeader>
          <td [attr.colspan]="columns.length + (rowExpandMode !== 'none' ? 1 : 0)">
            <ng-container *ngTemplateOutlet="rowGroupTemplateRef; context: { $implicit: item }"></ng-container>
          </td>
        </tr>
      </ng-template>
    }

    <ng-template pTemplate="body" let-item let-expanded="expanded">
      <!-- row for each data row-->
      <tr [ngClass]="rowClassCallable(item, expanded)" [pSelectableRow]="item" [pSelectableRowDisabled]="(!hasSelectableRows)" (click)="onRowClick ? onRowClick($event, item) : true">
        @if (rowExpandMode !== 'none') {
          <td style="min-width: 3rem">
            <button type="button" pButton pRipple [pRowToggler]="item"
              [text]="true" [rounded]="true" [plain]="true" class="expander-button"
              [icon]="expanded ? 'fa fa-solid fa-chevron-down' : 'fa fa-solid fa-chevron-right'">
            </button>
          </td>
        }
        @if (checkboxSelection) {
          <td style="min-width: 60px; flex-grow: unset; text-align: center">
            @if (rowCanBeSelected(item)) {
              <p-tableCheckbox [value]="item"/>
            }
          </td>
        }
        @for (column of columns; track column.key) {
          @if (visibleColumnKeys.includes(column.key)) {
            <td [style]="'min-width: ' + column.minWidth" [class]="column.cellClass + ' ' + (column.filterType === FilterType.NUMERIC ? 'text-right' : '')">
              <span [class]="'cell-content ' + (prefixDetailUrlTemplate ? 'link' : '')">
                <ng-container *ngTemplateOutlet="column.template || defaultColumnTemplate; context:{ $implicit: item }"></ng-container>
                <ng-template #defaultColumnTemplate>
                  {{ item[column.key] }}
                </ng-template>
              </span>
            </td>
          }
        }
      </tr>
    </ng-template>

    @if (rowExpandMode !== 'none') {
      <ng-template pTemplate="rowexpansion" let-item>
        <tr [ngClass]="expandedRowContentClass">
          <td [attr.colspan]="columns.length + 1">
            <ng-container *ngTemplateOutlet="expansionTemplateRef; context: { $implicit: item }"></ng-container>
          </td>
        </tr>
      </ng-template>
    }
  </p-table>
</div>
